<div class="adminModal">
  <button class="adminModal__inspector" (click)="api().select({ type: 'toggleInspector' })">
    <svg
      fill="#000000"
      height="20px"
      width="20px"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 490.4 490.4"
      xml:space="preserve"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0" />
      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
      <g id="SVGRepo_iconCarrier">
        <g>
          <path
            d="M484.1,454.796l-110.5-110.6c29.8-36.3,47.6-82.8,47.6-133.4c0-116.3-94.3-210.6-210.6-210.6S0,94.496,0,210.796 s94.3,210.6,210.6,210.6c50.8,0,97.4-18,133.8-48l110.5,110.5c12.9,11.8,25,4.2,29.2,0C492.5,475.596,492.5,463.096,484.1,454.796z M41.1,210.796c0-93.6,75.9-169.5,169.5-169.5s169.6,75.9,169.6,169.5s-75.9,169.5-169.5,169.5S41.1,304.396,41.1,210.796z"
          />
        </g>
      </g>
    </svg>
  </button>
  <details open>
    <summary>Quiz settings</summary>
    <div>
      <select [(ngModel)]="goal" #select>
        @for (goal of goals; track goal.value) {
          <option [ngValue]="goal.value" [selected]="goal.value === goalEnum.prevent">
            {{ goal.label }}
          </option>
        }
      </select>
      <app-button
        uid="adminModal_skipQuiz"
        color="purple"
        text="white"
        label="Skip quiz"
        (click)="api().select({ type: 'skip', payload: { goal } })"
      />
      <app-button
        uid="adminModal_restartQuiz"
        color="white"
        text="purple"
        border="purple"
        label="Restart quiz"
        (click)="api().select({ type: 'restart' })"
      />
    </div>
  </details>

  <details open>
    <summary>Country settings</summary>
    <div>
      <app-searchable-select
        [items]="countries"
        [(value)]="selectedCountry"
        placeholder="Select Country"
        (valueChange)="onChangeCountry($event)"
      />
      @if (selectedCountry === 'US') {
        <div>
          <label for="experiment">Add US state code (2 characters)</label>
          <input type="text" [(ngModel)]="selectedRegion" id="region" />
        </div>
      }
      <app-button
        uid="adminModal_overrideCountry"
        color="purple"
        label="Override country"
        (click)="
          api().select({
            type: 'changeCountry',
            payload: { country: selectedCountry, region: selectedRegion },
          })
        "
      />
      <app-button
        uid="adminModal_clearOverrideCountry"
        color="white"
        text="purple"
        border="purple"
        label="Clear country override"
        (click)="api().select({ type: 'clearCountry' })"
      />
    </div>
  </details>

  <details open>
    <summary>Experiments</summary>
    <div>
      <details>
        <summary>Set Experiment Bucket</summary>
        <div>
          <label for="experiment">Experiment</label>
          <input type="text" [(ngModel)]="experiment" id="experiment" />
          <label for="bucket">Bucket</label>
          <input type="text" [(ngModel)]="bucket" id="bucket" />
          <app-button
            uid="adminModal_setExperiment"
            color="purple"
            label="Set Experiment"
            (click)="api().select({ type: 'setExperiment', payload: { experiment, bucket } })"
          />
        </div>
      </details>
      <app-button
        uid="adminModal_clearExperiments"
        color="white"
        text="purple"
        border="purple"
        label="Clear Experiments"
        (click)="api().select({ type: 'clearExperiments' })"
      />
    </div>
  </details>

  @if (!isProduction) {
    <details open>
      <summary>Skip payment <small>(Payment page only)</small></summary>
      <div>
        <input type="text" [(ngModel)]="paymentNonce" />
        <small
          >More nonces can be
          <a
            target="_blank"
            href="https://developer.paypal.com/braintree/docs/reference/general/testing/node"
            >found here</a
          ></small
        >
        <app-button
          [disabled]="!paymentNonce"
          uid="adminModal_triggerPayment"
          color="purple"
          label="Trigger payment"
          (click)="api().select({ type: 'triggerPaymentWithNonce', payload: paymentNonce })"
        />
      </div>
    </details>

    <details open>
      <summary>Set API url</summary>
      <div>
        <small>Allows making requests to a different NCBackend3 API url</small>
        <input type="text" [placeholder]="environmentApiUrl" [(ngModel)]="apiUrl" />
        <app-button
          uid="adminModal_setApiURL"
          color="purple"
          border="purple"
          label="Set API url"
          (click)="setAdminApiUrl(apiUrl)"
        />
        <app-button
          uid="adminModal_resetApiURL"
          color="white"
          text="purple"
          border="purple"
          label="Reset"
          (click)="setAdminApiUrl(undefined)"
        />
      </div>
    </details>
  }

  <details open>
    <summary>Time travel (refresh to apply)</summary>
    <div>
      <input type="datetime-local" [(ngModel)]="overrideTimeFormModel" />
      <app-button
        uid="adminModal_timeTravel"
        color="purple"
        label="Time travel"
        [disabled]="!overrideTimeFormModel()"
        (click)="api().select({ type: 'timeTravel', payload: { time: getAsIsoDateTime() } })"
      />
      <app-button
        uid="adminModal_resetTime"
        color="white"
        text="purple"
        border="purple"
        label="Reset time"
        (click)="api().select({ type: 'resetTime' })"
      />
    </div>
  </details>

  <details open>
    <summary>Log out user <small>(will also clear discount codes)</small></summary>
    <div>
      <app-button
        uid="adminModal_logOut"
        color="purple"
        label="Log out"
        (click)="api().select({ type: 'logOutUser' })"
      />
    </div>
  </details>

  <i>Not working?<br />Try hard-refreshing the page(⌘ + ⇧ + R) for the effects to take place.</i>
</div>
